function isQuestion(text) {
  const keywords = ["who", "what", "when", "where", "why", "how"];
  const questionWords = [
    "is",
    "are",
    "am",
    "was",
    "were",
    "do",
    "does",
    "did",
    "have",
    "has",
    "had",
    "can",
    "could",
    "will",
    "would",
    "shall",
    "should",
    "may",
    "might",
  ];
  const words = text.trim().toLowerCase().split(" ");

  // Check for question keywords or common question structures
  const containsQuestionKeyword = keywords.some((keyword) =>
    words.includes(keyword)
  );
  const startsWithQuestionWord = questionWords.some((word) =>
    text.trim().toLowerCase().startsWith(word)
  );

  return containsQuestionKeyword || startsWithQuestionWord;
}

export default isQuestion;
